import { render } from "./Panorama.vue?vue&type=template&id=70959ec4"
import script from "./Panorama.vue?vue&type=script&lang=js"
export * from "./Panorama.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__